var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchainIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.736457 2.72417C0.810514 2.66657 0.8784 2.60143 0.961371 2.5548L5.07497 0.2412C5.64549 -0.0804 6.35383 -0.0804 6.92434 0.2412L11.0386 2.55549C11.1216 2.60211 11.1888 2.66657 11.2629 2.72417L5.99931 5.88189L0.736457 2.72417ZM5.48571 6.77331L0.126857 3.558C0.0521142 3.76166 0 3.97491 0 4.19846V8.76531C0 9.44554 0.368229 10.075 0.960686 10.4083L5.07497 12.7226C5.20526 12.7959 5.34377 12.8481 5.48571 12.8878V6.77331ZM6.51429 6.77331V12.8878C6.65554 12.8481 6.79474 12.7959 6.92503 12.7226L11.0393 10.4083C11.6318 10.075 12 9.44554 12 8.76531V4.19846C12 3.97491 11.9472 3.76234 11.8731 3.558L6.51429 6.77331Z",
    fill: "#229EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIco);
export default __webpack_public_path__ + "static/media/blockchain_ico.db91c9e9bfa661ee408ba3d9e298dc52.svg";
export { ForwardRef as ReactComponent };